import { BCMSCurrency } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import "./styles.css";

export default function BillerPaymentView(props) {

    const description = props.description ?? "";
    let amount = "[$XX.XX]";
    const date = props.date ?? "[MM/DD/YY]";
    const status = props.status == undefined
        ? "[STATUS]"
        : props.status.charAt(0).toUpperCase() + props.status.slice(1);
    const showAutopay = props.showAutopay ?? false;

    // "Upcoming bills" in "Pay Bills" uses this component
    // but shows "Bill" info, not "Payment" info. No "Payment"
    // will be passed to this component in that case.
    const payment = props.payment ?? {};
    const paymentID = payment.id ? ("_" + payment.id) : "";

    // START: Set data points.
    const amountDescriptionDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Description" + paymentID } : {};
    const amountDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Amount" + paymentID } : {};
    const statusDataPoint = props.dataPoint ? { "data-point" : props.dataPoint + "_Status" + paymentID } : {};
    // END: Set data points.

    // type of promps.amount determines value of amount
    if(props.amount instanceof BCMSCurrency) {
        amount = props.amount.format();
    } else if(props.amount instanceof String) {
        amount = props.amount;
    }

    return (
        <div className="flex-container flex-vertical flex-width align-bottom biller-payment-view-container">
            <div className="amount-container flex-container flex-horizontal align-center">
                <p className="set-width sub-text gray-text flex-container flex-horizontal" { ...amountDescriptionDataPoint }>{ description }</p>
                <p className="set-width main-text set-width amount" { ...amountDataPoint }>{ amount }{ showAutopay && <SVGAsset id="TwoArrowsIcon" className="icon" /> }</p> 
                { props.recurring }
            </div>
            <p className="status-date-text gray-text sub-text" { ...statusDataPoint }>
                <span>{ status }</span> <span>{ date }</span>
            </p>
        </div>
    );
  }